export default __webpack_public_path__ + "static/media/activity-new-dark.f964dd69.svg";